import React from "react";
import { BookedCourtsResponse } from "../../../apis/types";
import {
  convertSecondsSlotsToTime,
  formatDateToDifferenceText,
} from "../../../utils/utils";

type props = {
  match: BookedCourtsResponse;
};

export const MatchDateAndTime: React.FC<props> = ({ match }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <span style={{ color: "#B04A3F", fontWeight: 600, fontSize: 12 }}>
        {formatDateToDifferenceText(
          match.bookingDate.includes("T")
            ? match.bookingDate.split("T")[0]
            : match.bookingDate
        )}
      </span>
      <span style={{ color: "#20594A", fontWeight: 500, fontSize: 12 }}>
        {convertSecondsSlotsToTime(
          match?.startSlotTime ?? 0,
          match?.endSlotTime ?? 0
        )}
      </span>
    </div>
  );
};
